namespace Ir.Components.User.UserPreferences {
    interface IViewModel {
        gridOptions: DevExpress.ui.dxDataGrid.Properties;
        gridComponent: DevExpress.ui.dxDataGrid;

        dataSource: Array<any>;
    }
    interface IParams {
        userId: number;
    }

    let userPreferences: UserPreferencesConfig;

    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;
        let groups = [{ id: 1, name: "Workbook List" }];
        load(self, params);

        self.gridOptions = {
            height: "100%",
            width: "100%",
            loadPanel: {
                enabled: false
            },
            showBorders: true,
            showColumnLines: false,
            showRowLines: true,
            showColumnHeaders: false,
            grouping: {
                autoExpandAll: true,
            },
            paging: {
                enabled: false
            },
            groupPanel: {
                visible: false,
            },
            searchPanel: {
                visible: true,
                highlightSearchText: true,
            },
            keyExpr: 'name',
            dataSource: self.dataSource,
            columns: [
                {
                    dataField: "groupId",
                    groupIndex: 0,
                    groupCellTemplate: function (element, options) {
                        let group = groups.find(function (x) { return x.id === options.value; });
                        element.text(group.name);
                    },
                },
                {
                    dataField: "name",
                    allowEditing: false,
                    width: 140,
                    cssClass: "dx-editor-cell",
                },                
                {
                    dataField: "value",
                    showEditorAlways: true,
                    alignment: "left",
                    width: 380
                },
                {
                    dataField: "description",
                    allowEditing: false,
                    encodeHtml: false,
                }
            ],
            editing: {
                mode: 'cell',
                allowAdding: false,
                allowUpdating: true,
                allowDeleting: false,
                startEditAction: 'click',
            },
            repaintChangesOnly: true,
            onInitialized(e) {
                self.gridComponent = e.component;
            },
            onEditorPreparing(e) {
                onEditorPreparing(e);
            }
        };
    }

    function load(self: IViewModel, params: IParams) {
        self.dataSource = [];
        let o = {
            url: urlConfigs.user + "/GetUserPreferences",
            data: { userId: params.userId },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (result: any, e) {
            userPreferences = new UserPreferencesConfig(result.preferences);
            self.dataSource.push({
                editorName: "dxTagBox",
                groupId: 1,
                name: "Columns",
                description: "Select the workbook information to automatically display to the users.",
                value: userPreferences.showColumns,
                options: userPreferences.getColumnsOptions(),
                onValueChanged(value: any) {
                    userPreferences.showColumns = value;
                }
            });
            self.dataSource.push({
                editorName: "dxSelectBox",
                groupId: 1,
                name: "View",
                description: "<b>All</b> to show all workbooks available to the user.<br /><b>Favorites</b> to show all workbooks that have been set as favorites.<br /><b>Others</b> to show all workbooks shared with the user.",
                value: userPreferences.showWorkbooksMode,
                options: [
                    { id: ShowWorkbooksModeEnum.All, name: "All" },
                    { id: ShowWorkbooksModeEnum.Favorites, name: "Favorites" },
                    { id: ShowWorkbooksModeEnum.Recent, name: "Recent" },
                ],
                onValueChanged(value: ShowWorkbooksModeEnum) {
                    userPreferences.showWorkbooksMode = value;

                    if (value === ShowWorkbooksModeEnum.Favorites) {
                        self.gridComponent.cellValue(self.gridComponent.getRowIndexByKey("Group By"), "value", HomeWorkbookGroupingEnum.None);
                        userPreferences.workbookGrouping = HomeWorkbookGroupingEnum.None;
                    }
                    else {
                        self.gridComponent.cellValue(self.gridComponent.getRowIndexByKey("Group By"), "value", userPreferences.workbookGrouping);
                    }

                    //self.gridComponent.saveEditData();
                }
            });
            self.dataSource.push({
                editorName: "dxSelectBox",
                groupId: 1,
                name: "Owners",
                description: "<b>All</b> to show all workbooks available to the user regardless of the owner/creator of the workbook.<br /><b>Mine</b> to show only those workbooks created by the user.<br /><b>Share</b> to show only those workbooks shared with the user but created by other users.",
                value: userPreferences.showWorkbooksType,
                options: [
                    { id: ShowWorkbooksTypeEnum.All, name: "All" },
                    { id: ShowWorkbooksTypeEnum.Mine, name: "Mine" },
                    { id: ShowWorkbooksTypeEnum.OtherUsers, name: "Others" },
                ],
                onValueChanged(value: ShowWorkbooksTypeEnum) {
                    userPreferences.showWorkbooksType = value;
                }
            });
            self.dataSource.push({
                editorName: "dxSelectBox",
                groupId: 1,
                name: "Group By",
                description: "The workbooks may be viewed in grouped sections.<br />These sections can be set to default display in groupings of workbook <b>Mapping</b> type, workbook <b>Owner</b> or workbook <b>Category</b>.",
                value: userPreferences.workbookGrouping,
                options: [
                    { id: HomeWorkbookGroupingEnum.None, name: "None" },
                    { id: HomeWorkbookGroupingEnum.Mapping, name: "Mapping" },
                    { id: HomeWorkbookGroupingEnum.Owner, name: "Owner" },
                    { id: HomeWorkbookGroupingEnum.Category, name: "Category" },
                ],
                filter(value) {
                    if (userPreferences.showWorkbooksMode === ShowWorkbooksModeEnum.Favorites) {
                        return value.id === HomeWorkbookGroupingEnum.None;
                    }

                    return true;
                },
                onValueChanged(value: HomeWorkbookGroupingEnum) {
                    userPreferences.workbookGrouping = value;
                }
            });
            self.dataSource.push({
                editorName: "dxSwitch",
                groupId: 1,
                name: "Show Workbook Tabs",
                description: "Show all workbook tabs, allowing the user to access them directly.",
                value: userPreferences.showTabs,
                onValueChanged(value: boolean) {
                    userPreferences.showTabs = value;
                }
            });
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            //errorItem.userMessage = userMessage;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    function onEditorPreparing(e) {
        if (!e?.row)
            return;

        e.editorName = e.row.data.editorName;
        e.editorOptions.value = e.value;
        if (e.row.data.editorName === "dxTagBox") {
            e.editorOptions.items = e.row.data.options;
            e.editorOptions.showSelectionControls = true;
            e.editorOptions.onValueChanged = function(ev) {
                e.row.data.onValueChanged(ev.value);
            }
        }
        else if (e.row.data.editorName === "dxSelectBox") {
            e.editorOptions.dataSource = e.row.data.filter ? e.row.data.options.filter(e.row.data.filter) : e.row.data.options;
            e.editorOptions.valueExpr = "id";
            e.editorOptions.displayExpr = "name";
            e.editorOptions.searchEnabled = false;
            e.editorOptions.onValueChanged = function (ev) {
                e.row.data.onValueChanged(ev.value);
            }
        }
        else if (e.row.data.editorName === "dxSwitch") {
            e.editorOptions.onValueChanged = function (ev) {
                e.row.data.onValueChanged(ev.value);
            }
        }
    }; 
    
    export function save(element: JQuery<Element>, callback: Function) {
        const grid = $("#userPreferencesGrid", element).data("dxDataGrid");
        if (grid) {
            if (grid.hasEditData()) {
                grid.saveEditData().done(function () {
                    callback(userPreferences);
                });
            }
            else {
                callback(userPreferences);
            }
        }
        else {
            callback(null);
        }
    }

    export function validate(element: JQuery<Element>, callback: Function) {
        //const grid = $("#userGroupAccessGrid", element).data("dxDataGrid") as any;
        //if (grid) {
        //    const currentChanges = grid.option('editing.changes') as any;
        //    const fakeChanges = grid.getVisibleRows().map((row) => ({ type: 'update', key: row.key, data: {} }));

        //    grid.option('editing.changes', [...currentChanges, ...fakeChanges]);
        //    grid.repaint();

        //    grid.getController('validating').validate(true).then((result) => {
        //        return callback(result);
        //    });
        //}
        //else {
        //    callback(true);
        //}
    }
}